<section class="page-header">
	<div>
		<p class="fs-xxs gray">
			Envie as bases Saúde e Dental da organização, resolva pendências de
			comparação e acompanhe as divergências encontradas.
		</p>
	</div>
	<div class="model-download-actions">
		<button
			mat-stroked-button
			color="primary"
			type="button"
			(click)="downloadModelTemplate('health')"
		>
			<mat-icon svgIcon="sanus-download"></mat-icon>
			<span>Baixar modelo Saúde</span>
		</button>
		<button
			mat-stroked-button
			color="primary"
			type="button"
			(click)="downloadModelTemplate('dental')"
		>
			<mat-icon svgIcon="sanus-download"></mat-icon>
			<span>Baixar modelo Dental</span>
		</button>
	</div>
</section>
<section class="upload-section">
	<div class="section-header">
		<div>
			<h3 class="fw-bold fs-xs">Upload das bases</h3>
			<p class="fs-xxs gray">
				Envie uma base Saúde, uma base Dental ou ambas para iniciar a
				reconciliação.
			</p>
		</div>
		<div class="upload-actions">
			<mat-form-field
				*ngIf="isStandardUploadMode"
				appearance="outline"
				class="standard-import-select"
				subscriptSizing="dynamic"
			>
				<mat-label>Tipo de importação</mat-label>
				<mat-select
					[value]="standardImportModel"
					[disabled]="isUploadActionProcessing || isProcessingReconciliation"
					(selectionChange)="onStandardImportModelChange($event.value)"
				>
					<mat-option value="SANUS_STANDARD">Padrão Sanus</mat-option>
					<mat-option value="AMIL">Amil</mat-option>
					<mat-option value="BRADESCO_PROVIDER">
						Bradesco Empresarial
					</mat-option>
					<mat-option value="BRADESCO_SPG">Bradesco SPG</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field
				*ngIf="canSelectScopeMode"
				appearance="outline"
				class="scope-mode-select"
				subscriptSizing="dynamic"
			>
				<mat-label>Escopo</mat-label>
				<mat-select
					[value]="scopeMode"
					[disabled]="
						isUploadActionProcessing ||
						isProcessingReconciliation ||
						isScopeModeSelectionLocked
					"
					(selectionChange)="onScopeModeChange($event.value)"
				>
					<mat-option
						*ngFor="
							let option of scopeModeOptions;
							trackBy: trackByScopeModeOption
						"
						[value]="option.value"
					>
						{{ option.label }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<button
				mat-flat-button
				color="primary"
				[disabled]="
					!canRunUploadAction ||
					isUploadActionProcessing ||
					isProcessingReconciliation
				"
				(click)="onUploadAction()"
			>
				<span *ngIf="isUploadActionProcessing" class="button-loading-content">
					<mat-spinner diameter="18"></mat-spinner>
					<span>{{ uploadActionLoadingLabel }}</span>
				</span>
				<span *ngIf="!isUploadActionProcessing">
					{{ uploadActionLabel }}
				</span>
			</button>
		</div>
	</div>

	<div
		class="upload-mode-selector"
		role="radiogroup"
		aria-label="Tipo de layout"
	>
		<button
			mat-stroked-button
			type="button"
			[class.active]="isStandardUploadMode"
			[disabled]="isUploadActionProcessing || isProcessingReconciliation"
			(click)="onUploadModeChange('STANDARD')"
		>
			<div>
				<span class="fw-bold">Layout padrão</span>
				<small>Use as bases Saúde e Dental no modelo atual.</small>
			</div>
		</button>
		<button
			mat-stroked-button
			type="button"
			[class.active]="isFlexibleUploadMode"
			[disabled]="isUploadActionProcessing || isProcessingReconciliation"
			(click)="onUploadModeChange('FLEXIBLE')"
		>
			<div>
				<span class="fw-bold">Layout flexível</span>
				<small>Use bases fora do modelo padrão em um upload único.</small>
			</div>
		</button>
	</div>

	<div class="upload-grid" *ngIf="isStandardUploadMode">
		<div class="upload-card">
			<div class="upload-card__header">
				<h4 class="fw-bold fs-xxs">Base Saúde</h4>
				<label
					class="upload-trigger"
					for="health-upload"
					tabindex="0"
					[class.is-disabled]="isUploadTriggerBlocked('healthFile')"
					[attr.title]="getUploadTriggerTitle('healthFile')"
					(click)="onUploadTriggerClick($event, 'healthFile')"
					(keydown.enter)="onUploadTriggerClick($event, 'healthFile')"
					(keydown.space)="onUploadTriggerClick($event, 'healthFile')"
				>
					<mat-icon>upload_file</mat-icon>
					<span>{{ getUploadTriggerLabel('healthFile') }}</span>
				</label>
				<input
					id="health-upload"
					type="file"
					[attr.accept]="standardUploadFileAccept"
					[disabled]="isUploadTriggerBlocked('healthFile')"
					(change)="addFiles('healthFile', $any($event.target).files)"
				/>
			</div>

			<div class="upload-empty" *ngIf="!healthFile && !persistedHealthFile">
				Nenhuma base Saúde selecionada.
			</div>

			<div
				class="upload-list"
				*ngIf="!healthFile && persistedHealthFile as originalFile"
			>
				<div class="upload-item">
					<div>
						<p class="fw-bold fs-xxs">{{ originalFile.fileName }}</p>
						<span class="fs-xxxs gray">
							{{ formatOriginalFileSize(originalFile.fileSize) }}
						</span>
					</div>
					<div class="upload-item__actions">
						<button
							mat-stroked-button
							color="primary"
							type="button"
							[attr.title]="
								originalFile.hasDownload
									? 'Baixar arquivo original'
									: 'Arquivo original indisponível para sessões antigas'
							"
							[disabled]="
								!originalFile.hasDownload ||
								isDownloadingOriginalFileId === originalFile.id
							"
							(click)="downloadOriginalFile(originalFile)"
						>
							<mat-spinner
								*ngIf="isDownloadingOriginalFileId === originalFile.id"
								diameter="16"
							></mat-spinner>
							<mat-icon *ngIf="isDownloadingOriginalFileId !== originalFile.id">
								file_download
							</mat-icon>
							<span>Baixar</span>
						</button>
						<button
							mat-icon-button
							type="button"
							[disabled]="isUploadSelectionBlocked"
							(click)="removePersistedOriginalFile(originalFile)"
						>
							<mat-icon>close</mat-icon>
						</button>
					</div>
				</div>
			</div>

			<div class="upload-list" *ngIf="healthFile">
				<div class="upload-item">
					<div>
						<p class="fw-bold fs-xxs">{{ healthFile.name }}</p>
						<span class="fs-xxxs gray">
							{{ (healthFile.size / 1024 / 1024).toFixed(2) }} MB
						</span>
					</div>
					<div class="upload-item__actions">
						<button
							*ngIf="persistedHealthFile as originalFile"
							mat-stroked-button
							color="primary"
							type="button"
							[attr.title]="
								originalFile.hasDownload
									? 'Baixar arquivo original'
									: 'Arquivo original indisponível para sessões antigas'
							"
							[disabled]="
								!originalFile.hasDownload ||
								isDownloadingOriginalFileId === originalFile.id
							"
							(click)="downloadOriginalFile(originalFile)"
						>
							<mat-spinner
								*ngIf="isDownloadingOriginalFileId === originalFile.id"
								diameter="16"
							></mat-spinner>
							<mat-icon *ngIf="isDownloadingOriginalFileId !== originalFile.id">
								file_download
							</mat-icon>
							<span>Baixar</span>
						</button>
						<button
							mat-icon-button
							type="button"
							[disabled]="isUploadSelectionBlocked"
							(click)="removeSelectedFile('healthFile')"
						>
							<mat-icon>close</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="upload-card">
			<div class="upload-card__header">
				<h4 class="fw-bold fs-xxs">Base Dental</h4>
				<label
					class="upload-trigger"
					for="dental-upload"
					tabindex="0"
					[class.is-disabled]="isUploadTriggerBlocked('dentalFile')"
					[attr.title]="getUploadTriggerTitle('dentalFile')"
					(click)="onUploadTriggerClick($event, 'dentalFile')"
					(keydown.enter)="onUploadTriggerClick($event, 'dentalFile')"
					(keydown.space)="onUploadTriggerClick($event, 'dentalFile')"
				>
					<mat-icon>upload_file</mat-icon>
					<span>{{ getUploadTriggerLabel('dentalFile') }}</span>
				</label>
				<input
					id="dental-upload"
					type="file"
					[attr.accept]="standardUploadFileAccept"
					[disabled]="isUploadTriggerBlocked('dentalFile')"
					(change)="addFiles('dentalFile', $any($event.target).files)"
				/>
			</div>

			<div class="upload-empty" *ngIf="!dentalFile && !persistedDentalFile">
				Nenhuma base Dental selecionada.
			</div>

			<div
				class="upload-list"
				*ngIf="!dentalFile && persistedDentalFile as originalFile"
			>
				<div class="upload-item">
					<div>
						<p class="fw-bold fs-xxs">{{ originalFile.fileName }}</p>
						<span class="fs-xxxs gray">
							{{ formatOriginalFileSize(originalFile.fileSize) }}
						</span>
					</div>
					<div class="upload-item__actions">
						<button
							mat-stroked-button
							color="primary"
							type="button"
							[attr.title]="
								originalFile.hasDownload
									? 'Baixar arquivo original'
									: 'Arquivo original indisponível para sessões antigas'
							"
							[disabled]="
								!originalFile.hasDownload ||
								isDownloadingOriginalFileId === originalFile.id
							"
							(click)="downloadOriginalFile(originalFile)"
						>
							<mat-spinner
								*ngIf="isDownloadingOriginalFileId === originalFile.id"
								diameter="16"
							></mat-spinner>
							<mat-icon *ngIf="isDownloadingOriginalFileId !== originalFile.id">
								file_download
							</mat-icon>
							<span>Baixar</span>
						</button>
						<button
							mat-icon-button
							type="button"
							[disabled]="isUploadSelectionBlocked"
							(click)="removePersistedOriginalFile(originalFile)"
						>
							<mat-icon>close</mat-icon>
						</button>
					</div>
				</div>
			</div>

			<div class="upload-list" *ngIf="dentalFile">
				<div class="upload-item">
					<div>
						<p class="fw-bold fs-xxs">{{ dentalFile.name }}</p>
						<span class="fs-xxxs gray">
							{{ (dentalFile.size / 1024 / 1024).toFixed(2) }} MB
						</span>
					</div>
					<div class="upload-item__actions">
						<button
							*ngIf="persistedDentalFile as originalFile"
							mat-stroked-button
							color="primary"
							type="button"
							[attr.title]="
								originalFile.hasDownload
									? 'Baixar arquivo original'
									: 'Arquivo original indisponível para sessões antigas'
							"
							[disabled]="
								!originalFile.hasDownload ||
								isDownloadingOriginalFileId === originalFile.id
							"
							(click)="downloadOriginalFile(originalFile)"
						>
							<mat-spinner
								*ngIf="isDownloadingOriginalFileId === originalFile.id"
								diameter="16"
							></mat-spinner>
							<mat-icon *ngIf="isDownloadingOriginalFileId !== originalFile.id">
								file_download
							</mat-icon>
							<span>Baixar</span>
						</button>
						<button
							mat-icon-button
							type="button"
							[disabled]="isUploadSelectionBlocked"
							(click)="removeSelectedFile('dentalFile')"
						>
							<mat-icon>close</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="upload-grid" *ngIf="isFlexibleUploadMode">
		<div class="upload-card upload-card--wide">
			<div class="upload-card__header">
				<h4 class="fw-bold fs-xxs">Bases em layout flexível</h4>
				<label
					class="upload-trigger"
					for="flexible-upload"
					[class.is-disabled]="isUploadSelectionBlocked"
				>
					<mat-icon>upload_file</mat-icon>
					<span>Selecionar bases</span>
				</label>
				<input
					id="flexible-upload"
					type="file"
					multiple
					[attr.accept]="acceptedReconciliationFileAccept"
					[disabled]="isUploadSelectionBlocked"
					(change)="addFlexibleFiles($any($event.target).files)"
				/>
			</div>

			<div
				class="upload-empty"
				*ngIf="
					flexibleFiles.length === 0 && persistedFlexibleFiles.length === 0
				"
			>
				Nenhuma base selecionada para análise.
			</div>

			<div
				class="upload-list"
				*ngIf="flexibleFiles.length === 0 && persistedFlexibleFiles.length > 0"
			>
				<div
					class="upload-item"
					*ngFor="
						let originalFile of persistedFlexibleFiles;
						trackBy: trackByOriginalFile
					"
				>
					<div>
						<p class="fw-bold fs-xxs">{{ originalFile.fileName }}</p>
						<span class="fs-xxxs gray">
							{{ formatOriginalFileSize(originalFile.fileSize) }}
						</span>
					</div>
					<button
						mat-stroked-button
						color="primary"
						type="button"
						[attr.title]="
							originalFile.hasDownload
								? 'Baixar arquivo original'
								: 'Arquivo original indisponível para sessões antigas'
						"
						[disabled]="
							!originalFile.hasDownload ||
							isDownloadingOriginalFileId === originalFile.id
						"
						(click)="downloadOriginalFile(originalFile)"
					>
						<mat-spinner
							*ngIf="isDownloadingOriginalFileId === originalFile.id"
							diameter="16"
						></mat-spinner>
						<mat-icon *ngIf="isDownloadingOriginalFileId !== originalFile.id">
							file_download
						</mat-icon>
						<span>Baixar</span>
					</button>
					<button
						mat-icon-button
						type="button"
						[disabled]="isUploadSelectionBlocked"
						(click)="removePersistedOriginalFile(originalFile)"
					>
						<mat-icon>close</mat-icon>
					</button>
				</div>
			</div>

			<div class="upload-list" *ngIf="flexibleFiles.length > 0">
				<div
					class="upload-item"
					*ngFor="
						let flexibleFile of flexibleFiles;
						let fileIndex = index;
						trackBy: trackByFile
					"
				>
					<div>
						<p class="fw-bold fs-xxs">{{ flexibleFile.name }}</p>
						<span class="fs-xxxs gray">
							{{ (flexibleFile.size / 1024 / 1024).toFixed(2) }} MB
						</span>
					</div>
					<button
						mat-icon-button
						type="button"
						[disabled]="isUploadSelectionBlocked"
						(click)="removeFlexibleFile(fileIndex)"
					>
						<mat-icon>close</mat-icon>
					</button>
				</div>
			</div>
		</div>
	</div>

	<div
		class="preflight-alert info mapping-analysis-alert"
		*ngIf="
			isFlexibleUploadMode &&
			mappingAnalysis &&
			(!confirmedMapping ||
				isConfirmingMapping ||
				isComparing ||
				isCompareProcessing)
		"
	>
		<ng-container *ngIf="isConfirmingMapping; else mappingConfirmationState">
			Confirmando mapeamento...
		</ng-container>
		<ng-template #mappingConfirmationState>
			<ng-container
				*ngIf="
					confirmedMapping && (isComparing || isCompareProcessing);
					else mappingPendingReview
				"
			>
				Mapeamento confirmado. Processando bases...
			</ng-container>
		</ng-template>
		<ng-template #mappingPendingReview>
			Análise concluída:
			{{ mappingAnalysis.files.length }} arquivo(s) e
			{{ mappingAnalysis.sources.length }} fonte(s). Revise o mapeamento antes
			de criar o preflight.
		</ng-template>
	</div>
</section>

<div
	class="preflight-alert info processing-alert"
	*ngIf="isProcessingReconciliation"
>
	<mat-spinner diameter="18"></mat-spinner>
	<span>{{ processingStateMessage }}</span>
</div>

<div
	class="preflight-alert error processing-alert"
	*ngIf="processingErrorMessage"
>
	<span>{{ processingErrorMessage }}</span>
	<button
		*ngIf="hasUnknownApplyResult"
		mat-stroked-button
		type="button"
		[disabled]="isApplying"
		(click)="onVerifyUnknownApplyResult()"
	>
		Verificar resultado
	</button>
</div>

<section class="history-toggle">
	<div class="section-header">
		<div>
			<h3 class="fw-bold fs-xs">Comparações recentes</h3>
			<p class="fs-xxs gray">
				Abra o histórico apenas quando quiser reusar uma sessão anterior.
			</p>
		</div>
		<button
			mat-stroked-button
			color="primary"
			type="button"
			(click)="onToggleRecentSessions()"
		>
			{{ showRecentSessions ? 'Esconder histórico' : 'Ver histórico' }}
		</button>
	</div>
</section>

<section class="recent-sessions" *ngIf="showRecentSessions">
	<div class="section-header">
		<div>
			<h3 class="fw-bold fs-xs">Comparações recentes</h3>
			<p class="fs-xxs gray">
				Reabra sessões anteriores sem precisar rodar uma nova comparação.
			</p>
		</div>
	</div>

	<div class="loading-state" *ngIf="isLoadingSessions">
		<mat-spinner diameter="32"></mat-spinner>
	</div>

	<div
		class="empty-state"
		*ngIf="!isLoadingSessions && recentSessions.length === 0"
	>
		Nenhuma sessão de reconciliação encontrada.
	</div>

	<div
		class="session-list"
		*ngIf="!isLoadingSessions && recentSessions.length > 0"
	>
		<div
			class="session-card"
			*ngFor="let session of recentSessions; trackBy: trackBySession"
			[class.active]="comparisonId === session.id"
			role="button"
			tabindex="0"
			(click)="loadRecentSession(session)"
			(keydown.enter)="loadRecentSession(session)"
			(keydown.space)="loadRecentSession(session); $event.preventDefault()"
		>
			<div class="session-card__top">
				<div>
					<p class="fw-bold fs-xxs">
						Sessão {{ session.createdAt | date: 'dd/MM/yyyy HH:mm' }}
					</p>
					<span class="fs-xxxs gray">
						{{ session.total }} divergência(s) -
						{{ session.appliedCount ?? 0 }} aplicada(s)
						<span *ngIf="session.createdByName">
							- {{ session.createdByName }}
						</span>
					</span>
				</div>
				<div class="session-card__actions">
					<span class="status-chip">
						{{ getSessionScopeLabel(session) }}
					</span>
					<span
						class="status-chip"
						[ngClass]="getSessionProgressStatusClass(session)"
					>
						{{ getSessionProgressStatusLabel(session) }}
					</span>
					<button
						mat-stroked-button
						color="primary"
						type="button"
						[disabled]="!canExportHistorySession(session)"
						[attr.title]="
							session.total > 0
								? 'Exportar auditoria da sessão'
								: 'Compare a base antes de exportar o histórico'
						"
						(click)="onExportHistorySession(session, $event)"
					>
						<mat-spinner
							*ngIf="isExportingHistory(session.id)"
							diameter="16"
						></mat-spinner>
						<span *ngIf="!isExportingHistory(session.id)">
							Exportar layout do histórico
						</span>
					</button>
				</div>
			</div>
		</div>
	</div>

	<app-pagination
		*ngIf="sessionsTotalPages > 1"
		[count]="sessionsCount"
		[currentPage]="sessionsCurrentPage"
		[limit]="sessionLimit"
		[totalPages]="sessionsTotalPages"
		(pageChange)="onChangeSessionsPage($event)"
	></app-pagination>
</section>

<section class="cards-section" *ngIf="hasReconciliationLoaded">
	<div class="preflight-alert info" *ngIf="showDentalUnavailableAlert">
		Esta empresa não possui Dental cadastrado. Divergências Dental não serão
		geradas.
	</div>

	<div class="cards-guidance-banner">
		<mat-icon>info</mat-icon>
		<span>
			Importante: Realizar os ajustes na primeira linha para considerar
			posteriormente os demais resultados.
		</span>
	</div>

	<div class="summary-grid summary-grid--fixed cards-grid">
		<div
			class="summary-card"
			*ngFor="let card of firstRowCards; trackBy: trackByReconciliationCard"
			[class.active]="activeCardKey === card.key"
			role="button"
			tabindex="0"
			[attr.aria-pressed]="activeCardKey === card.key"
			[attr.title]="card.description"
			(click)="onSelectReconciliationCard(card)"
			(keydown.enter)="onSelectReconciliationCard(card)"
			(keydown.space)="
				onSelectReconciliationCard(card); $event.preventDefault()
			"
		>
			<div class="summary-card__header">
				<div class="summary-card__content">
					<span class="summary-card__count">{{ card.count }}</span>
					<span class="summary-card__label">{{ card.label }}</span>
				</div>
				<button
					mat-icon-button
					type="button"
					class="summary-card__guidance-toggle"
					[attr.aria-expanded]="isReconciliationCardGuidanceExpanded(card)"
					[attr.aria-label]="getReconciliationCardGuidanceAriaLabel(card)"
					[matTooltip]="getReconciliationCardGuidanceTooltip(card)"
					(click)="onToggleReconciliationCardGuidance(card, $event)"
					(keydown.enter)="$event.stopPropagation()"
					(keydown.space)="$event.stopPropagation()"
				>
					<mat-icon>
						{{
							isReconciliationCardGuidanceExpanded(card)
								? 'expand_less'
								: 'expand_more'
						}}
					</mat-icon>
				</button>
			</div>
			<p
				class="summary-card__guidance"
				*ngIf="isReconciliationCardGuidanceExpanded(card)"
			>
				{{ getReconciliationCardGuidance(card) }}
			</p>
		</div>

		<div
			class="summary-card"
			*ngFor="
				let card of secondRowCards;
				let cardIndex = index;
				trackBy: trackByReconciliationCard
			"
			[class.summary-card--row-start]="cardIndex === 0"
			[class.active]="activeCardKey === card.key"
			role="button"
			tabindex="0"
			[attr.aria-pressed]="activeCardKey === card.key"
			[attr.title]="card.description"
			(click)="onSelectReconciliationCard(card)"
			(keydown.enter)="onSelectReconciliationCard(card)"
			(keydown.space)="
				onSelectReconciliationCard(card); $event.preventDefault()
			"
		>
			<div class="summary-card__header">
				<div class="summary-card__content">
					<span class="summary-card__count">{{ card.count }}</span>
					<span class="summary-card__label">{{ card.label }}</span>
				</div>
				<button
					mat-icon-button
					type="button"
					class="summary-card__guidance-toggle"
					[attr.aria-expanded]="isReconciliationCardGuidanceExpanded(card)"
					[attr.aria-label]="getReconciliationCardGuidanceAriaLabel(card)"
					[matTooltip]="getReconciliationCardGuidanceTooltip(card)"
					(click)="onToggleReconciliationCardGuidance(card, $event)"
					(keydown.enter)="$event.stopPropagation()"
					(keydown.space)="$event.stopPropagation()"
				>
					<mat-icon>
						{{
							isReconciliationCardGuidanceExpanded(card)
								? 'expand_less'
								: 'expand_more'
						}}
					</mat-icon>
				</button>
			</div>
			<p
				class="summary-card__guidance"
				*ngIf="isReconciliationCardGuidanceExpanded(card)"
			>
				{{ getReconciliationCardGuidance(card) }}
			</p>
		</div>
	</div>
</section>

<section class="comparison-section" *ngIf="hasReconciliationLoaded">
	<div class="top-card-actions" *ngIf="canShowTopCardActions">
		<div>
			<h4 class="fw-bold fs-xxs">{{ activeTopCardApplyLabel }}</h4>
			<p class="fs-xxs gray">
				Revise os casos do card selecionado e aplique quando a fila estiver
				pronta.
			</p>
		</div>
		<div class="top-card-actions__buttons">
			<button
				class="apply-loading-button"
				mat-flat-button
				color="primary"
				type="button"
				[disabled]="!canApplyTopCard"
				(click)="onApplyTopCard()"
			>
				<span *ngIf="isApplying" class="button-loading-content">
					<mat-spinner diameter="18"></mat-spinner>
					<span>Aplicando</span>
				</span>
				<span *ngIf="!isApplying">{{ activeTopCardApplyLabel }}</span>
			</button>
			<button
				mat-stroked-button
				color="primary"
				class="top-card-secondary-action"
				type="button"
				[disabled]="
					activeTopCardPendingCount === 0 ||
					isExportingPreflightPendencies ||
					isExportingDuplicateInFile
				"
				(click)="onExportActiveTopCard()"
			>
				<mat-spinner
					*ngIf="isExportingPreflightPendencies || isExportingDuplicateInFile"
					diameter="16"
				></mat-spinner>
				<span>{{ activeTopCardExportLabel }}</span>
			</button>
			<label
				*ngIf="canShowTopCardImportButton"
				for="top-card-return-file"
				class="top-card-secondary-action"
				[class.is-loading]="
					isImportingPreflightPendencies || isImportingDuplicateReturn
				"
				[class.is-disabled]="
					activeTopCardPendingCount === 0 || isProcessingReconciliation
				"
			>
				<mat-spinner
					*ngIf="isImportingPreflightPendencies || isImportingDuplicateReturn"
					diameter="16"
				></mat-spinner>
				<span>{{ activeTopCardImportLabel }}</span>
				<input
					id="top-card-return-file"
					type="file"
					accept=".xlsx"
					[disabled]="
						activeTopCardPendingCount === 0 ||
						isImportingPreflightPendencies ||
						isImportingDuplicateReturn ||
						isProcessingReconciliation
					"
					(change)="
						onImportActiveTopCard($any($event.target).files);
						$any($event.target).value = ''
					"
				/>
			</label>
		</div>
	</div>

	<div class="filters-section" [formGroup]="filterForm">
		<div class="filters-grid">
			<mat-form-field appearance="outline">
				<mat-label>Categoria</mat-label>
				<mat-select formControlName="field">
					<mat-option
						*ngFor="let option of fieldOptions"
						[value]="option.value"
					>
						<span [attr.title]="option.description || null">
							{{ option.label }}
						</span>
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline">
				<mat-label>Status</mat-label>
				<mat-select formControlName="status">
					<mat-option
						*ngFor="let option of itemStatusOptions"
						[value]="option.value"
					>
						{{ option.label }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline">
				<mat-label>Operadora</mat-label>
				<input matInput type="text" formControlName="carrier" />
			</mat-form-field>

			<mat-form-field appearance="outline">
				<mat-label>Buscar por CPF ou nome</mat-label>
				<input
					matInput
					type="text"
					formControlName="search"
					(keyup.enter)="onApplyFilters()"
				/>
			</mat-form-field>

			<mat-form-field appearance="outline">
				<mat-label>Linhas por página</mat-label>
				<mat-select formControlName="limit">
					<mat-option *ngFor="let option of limitOptions" [value]="option">
						{{ option }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="filters-actions">
			<button mat-stroked-button color="primary" (click)="onClearFilters()">
				Limpar filtros
			</button>
		</div>
	</div>

	<div
		class="pending-bar"
		*ngIf="isDivergenceCardActive && pendingDisplayTotal > 0"
	>
		<div class="pending-bar__content">
			<div>
				<h4 class="fw-bold fs-xxs">
					{{ pendingDisplayTotal }} alterações pendentes
				</h4>
				<p class="fs-xxs gray">
					Revise as alterações antes de aplicar na plataforma.
				</p>
			</div>
			<p class="fs-xxs pending-alert" *ngIf="pendingManualReviewCount > 0">
				{{ pendingManualReviewCount }} casos precisam de revisão obrigatória
				antes da confirmação.
			</p>
			<div class="pending-summary-list">
				<span
					class="review-badge"
					[class.queued]="summary.action !== 'IGNORE_ITEM'"
					[class.waiting]="summary.action === 'IGNORE_ITEM'"
					*ngFor="
						let summary of pendingActionSummaries;
						trackBy: trackByPendingSummary
					"
				>
					{{ summary.count }} {{ summary.label }}
				</span>
			</div>
		</div>
		<div class="pending-bar__actions">
			<button
				class="apply-loading-button"
				mat-flat-button
				color="primary"
				[disabled]="!canOpenApplyPreview"
				(click)="onOpenApplyPreview()"
			>
				<span *ngIf="isApplying" class="button-loading-content">
					<mat-spinner diameter="18"></mat-spinner>
					<span>Aplicando</span>
				</span>
				<span *ngIf="!isApplying">{{ applySectionButtonLabel }}</span>
			</button>

			<button
				*ngIf="canShowOperationalDivergenceExportButton"
				mat-stroked-button
				color="primary"
				type="button"
				[disabled]="isExportingOperationalDivergence"
				(click)="onExportOperationalDivergence()"
			>
				<mat-spinner
					*ngIf="isExportingOperationalDivergence"
					diameter="18"
				></mat-spinner>
				<span>{{ getOperationalDivergenceExportButtonLabel() }}</span>
			</button>
			<label
				*ngIf="canShowTitularityReturnImportButton"
				for="titularity-return-file-pending"
				class="complement-upload-btn"
				[class.is-loading]="isImportingTitularityReturn"
				[class.is-disabled]="isProcessingReconciliation"
			>
				<mat-spinner
					*ngIf="isImportingTitularityReturn"
					diameter="18"
				></mat-spinner>
				<span *ngIf="!isImportingTitularityReturn">
					Importar titularidades corrigidas
				</span>
				<input
					id="titularity-return-file-pending"
					type="file"
					accept=".xlsx"
					[disabled]="isImportingTitularityReturn || isProcessingReconciliation"
					(change)="
						onImportTitularityReturn($any($event.target).files);
						$any($event.target).value = ''
					"
				/>
			</label>

			<button
				*ngIf="canShowDuplicateExportButton"
				mat-stroked-button
				color="primary"
				type="button"
				[disabled]="isExportingDuplicateInFile"
				(click)="onExportDuplicateInFile()"
			>
				<mat-spinner
					*ngIf="isExportingDuplicateInFile"
					diameter="18"
				></mat-spinner>
				<span>Exportar duplicidades</span>
			</button>
			<label
				*ngIf="canShowDuplicateReturnImportButton"
				for="duplicate-return-file-pending"
				class="complement-upload-btn"
				[class.is-loading]="isImportingDuplicateReturn"
				[class.is-disabled]="isProcessingReconciliation"
			>
				<mat-spinner
					*ngIf="isImportingDuplicateReturn"
					diameter="18"
				></mat-spinner>
				<span>Importar duplicidades</span>
				<input
					id="duplicate-return-file-pending"
					type="file"
					accept=".xlsx"
					[disabled]="isImportingDuplicateReturn || isProcessingReconciliation"
					(change)="
						onImportDuplicateReturn($any($event.target).files);
						$any($event.target).value = ''
					"
				/>
			</label>

			<button
				*ngIf="canShowActiveMissingExportButton"
				mat-stroked-button
				color="primary"
				type="button"
				[disabled]="isExportingActiveMissingInDb"
				(click)="onExportActiveMissingInDb()"
			>
				<mat-spinner
					*ngIf="isExportingActiveMissingInDb"
					diameter="18"
				></mat-spinner>
				<span *ngIf="!isExportingActiveMissingInDb">
					Baixar layout com dados faltantes
				</span>
			</button>
			<label
				*ngIf="canShowActiveMissingExportButton"
				for="missing-data-complement-file-pending"
				class="complement-upload-btn"
				[class.is-loading]="isComplementingMissingData"
				[class.is-disabled]="isProcessingReconciliation"
			>
				<mat-spinner
					*ngIf="isComplementingMissingData"
					diameter="18"
				></mat-spinner>
				<span *ngIf="!isComplementingMissingData">
					Importar retorno com dados complementados
				</span>
				<input
					id="missing-data-complement-file-pending"
					type="file"
					accept=".xlsx"
					[disabled]="isComplementingMissingData || isProcessingReconciliation"
					(change)="
						onComplementMissingData($any($event.target).files);
						$any($event.target).value = ''
					"
				/>
			</label>
		</div>
	</div>

	<div
		class="pending-export-standalone"
		*ngIf="canShowActiveMissingExportButton && pendingDisplayTotal === 0"
	>
		<div class="pending-export-box">
			<button
				mat-stroked-button
				color="primary"
				type="button"
				[disabled]="isExportingActiveMissingInDb"
				(click)="onExportActiveMissingInDb()"
			>
				<mat-spinner
					*ngIf="isExportingActiveMissingInDb"
					diameter="18"
				></mat-spinner>
				<span *ngIf="!isExportingActiveMissingInDb">
					Baixar layout com dados faltantes
				</span>
			</button>
			<label
				for="missing-data-complement-file-standalone"
				class="complement-upload-btn"
				[class.is-loading]="isComplementingMissingData"
				[class.is-disabled]="isProcessingReconciliation"
			>
				<mat-spinner
					*ngIf="isComplementingMissingData"
					diameter="18"
				></mat-spinner>
				<span *ngIf="!isComplementingMissingData">
					Importar retorno com dados complementados
				</span>
				<input
					id="missing-data-complement-file-standalone"
					type="file"
					accept=".xlsx"
					[disabled]="isComplementingMissingData || isProcessingReconciliation"
					(change)="
						onComplementMissingData($any($event.target).files);
						$any($event.target).value = ''
					"
				/>
			</label>
		</div>
	</div>

	<div class="table-wrapper">
		<ng-container *ngIf="isUncomparedLinesActive; else nonUncomparedTable">
			<div class="loading-state" *ngIf="isLoadingPreflightRows">
				<mat-spinner diameter="40"></mat-spinner>
			</div>

			<div
				class="empty-state"
				*ngIf="!isLoadingPreflightRows && filteredUncomparedRows.length === 0"
			>
				Nenhuma linha não comparada encontrada.
			</div>

			<table
				class="comparison-table preflight-table"
				*ngIf="!isLoadingPreflightRows && filteredUncomparedRows.length > 0"
			>
				<thead>
					<tr>
						<th>Beneficiário</th>
						<th>CPF</th>
						<th>Operadora</th>
						<th>CNPJ</th>
						<th>Motivo</th>
						<th>Status</th>
						<th>Ação</th>
					</tr>
				</thead>
				<tbody>
					<tr
						*ngFor="
							let row of paginatedUncomparedRows;
							trackBy: trackByPreflightRow
						"
					>
						<td>{{ row.data?.beneficiaryName || '-' }}</td>
						<td>{{ formatCpf(row.data?.beneficiaryCpf) }}</td>
						<td>{{ row.data?.carrier || '-' }}</td>
						<td>{{ row.data?.sourceOrganizationCnpj || '-' }}</td>
						<td>{{ getPreflightIssueLabels(row) }}</td>
						<td>
							<span
								class="status-chip"
								[class.queued]="getPreflightRowStatusTone(row) === 'queued'"
								[class.review]="getPreflightRowStatusTone(row) === 'review'"
								[class.success]="getPreflightRowStatusTone(row) === 'success'"
								[class.waiting]="getPreflightRowStatusTone(row) === 'waiting'"
							>
								{{ getPreflightRowStatusLabel(row) }}
							</span>
						</td>
						<td>
							<div class="action-column">
								<button
									*ngIf="
										!isPreflightRowCompleted(row);
										else resolvedPreflightRowAction
									"
									mat-stroked-button
									color="primary"
									type="button"
									[disabled]="isPendingChangeMutationBlocked"
									(click)="onReviewPreflightRow(row)"
								>
									Revisão obrigatória
								</button>
								<ng-template #resolvedPreflightRowAction>
									<span class="fs-xxxs gray">Resolvido</span>
								</ng-template>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</ng-container>

		<ng-template #nonUncomparedTable>
			<ng-container
				*ngIf="isUnidentifiedOrganizationsActive; else divergenceTable"
			>
				<div
					class="loading-state"
					*ngIf="isLoadingUnidentifiedOrganizationGroups"
				>
					<mat-spinner diameter="40"></mat-spinner>
				</div>

				<div
					class="empty-state"
					*ngIf="
						!isLoadingUnidentifiedOrganizationGroups &&
						filteredUnidentifiedOrganizationGroups.length === 0
					"
				>
					Nenhuma organização não identificada encontrada.
				</div>

				<table
					class="comparison-table preflight-table"
					*ngIf="
						!isLoadingUnidentifiedOrganizationGroups &&
						filteredUnidentifiedOrganizationGroups.length > 0
					"
				>
					<thead>
						<tr>
							<th>Identificador</th>
							<th>Motivo</th>
							<th>Linhas afetadas</th>
							<th>Status</th>
							<th>Ação</th>
						</tr>
					</thead>
					<tbody>
						<tr
							*ngFor="
								let group of paginatedUnidentifiedOrganizationGroups;
								trackBy: trackByUnidentifiedOrganizationGroup
							"
						>
							<td>{{ getUnidentifiedOrganizationIdentifierLabel(group) }}</td>
							<td>{{ getPreflightIssueCodeLabels(group.issueCodes) }}</td>
							<td>
								{{ group.rowCount }} linha(s)
								<p class="fs-xxxs gray">
									{{ group.pendingCount }} pendente(s) -
									{{ group.onHoldCount }} em espera
								</p>
							</td>
							<td>
								<span
									class="status-chip"
									[class.queued]="
										getUnidentifiedOrganizationStatusTone(group) === 'queued'
									"
									[class.review]="
										getUnidentifiedOrganizationStatusTone(group) === 'review'
									"
									[class.success]="
										getUnidentifiedOrganizationStatusTone(group) === 'success'
									"
									[class.waiting]="
										getUnidentifiedOrganizationStatusTone(group) === 'waiting'
									"
								>
									{{ getUnidentifiedOrganizationStatusLabel(group) }}
								</span>
							</td>
							<td>
								<div class="action-column">
									<button
										*ngIf="
											group.status !== 'ELIGIBLE';
											else resolvedOrganizationGroupAction
										"
										mat-stroked-button
										color="primary"
										type="button"
										[disabled]="isPendingChangeMutationBlocked"
										(click)="onReviewUnidentifiedOrganizationGroup(group)"
									>
										Revisão obrigatória
									</button>
									<ng-template #resolvedOrganizationGroupAction>
										<span class="fs-xxxs gray">Resolvido</span>
									</ng-template>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</ng-container>
		</ng-template>

		<ng-template #divergenceTable>
			<div class="loading-state" *ngIf="isLoadingItems">
				<mat-spinner diameter="40"></mat-spinner>
			</div>

			<div class="empty-state" *ngIf="!isLoadingItems && items.length === 0">
				Nenhuma divergência encontrada para os filtros selecionados.
			</div>

			<table
				class="comparison-table"
				*ngIf="!isLoadingItems && items.length > 0"
			>
				<thead>
					<tr>
						<th>Categoria</th>
						<th>Status</th>
						<th>Beneficiário</th>
						<th>CPF</th>
						<th>Operadora</th>
						<th>Organização atual</th>
						<th>Valor na plataforma</th>
						<th>Valor na base do cliente</th>
						<th>Origem</th>
						<th>Ação sugerida</th>
						<th>Interação</th>
					</tr>
				</thead>
				<tbody>
					<tr
						*ngFor="let item of items; trackBy: trackByItem"
						[attr.id]="'reconciliation-item-' + item.id"
						[class.manual-review-highlight]="isManualReviewHighlighted(item.id)"
						[class.history-row-clickable]="isHistoryAvailable(item)"
						[attr.role]="isHistoryAvailable(item) ? 'button' : null"
						[attr.tabindex]="isHistoryAvailable(item) ? '0' : null"
						(click)="isHistoryAvailable(item) && onOpenHistory(item)"
						(keydown.enter)="isHistoryAvailable(item) && onOpenHistory(item)"
					>
						<td [attr.title]="getFieldDescription(item.field)">
							<div class="category-cell">
								<span>{{ getFieldLabel(item.field) }}</span>
							</div>
						</td>
						<td>
							<span
								class="status-chip"
								[class.error]="getItemStatusTone(item) === 'error'"
								[class.history-clickable]="isHistoryAvailable(item)"
								[class.success]="getItemStatusTone(item) === 'success'"
								[class.queued]="getItemStatusTone(item) === 'queued'"
								[class.review]="getItemStatusTone(item) === 'review'"
								[class.waiting]="getItemStatusTone(item) === 'waiting'"
							>
								{{ getItemStatusLabel(item) }}
							</span>
							<p class="fs-xxxs error-text" *ngIf="hasItemErrorMessage(item)">
								{{ getItemErrorMessage(item) }}
							</p>
						</td>
						<td>{{ item.beneficiaryName || '-' }}</td>
						<td>{{ formatCpf(item.beneficiaryCpf) }}</td>
						<td>
							{{ item.carrier || '-' }}
							<p
								class="fs-xxxs gray"
								*ngIf="getItemWalletKindLabel(item) !== '-'"
							>
								{{ getItemWalletKindLabel(item) }}
							</p>
						</td>
						<td class="compact-cell">{{ item.organizationName || '-' }}</td>
						<td class="compact-cell">
							{{ getStructuredValueLabel(item, 'dbValue') }}
						</td>
						<td class="compact-cell">
							{{ getStructuredValueLabel(item, 'externalValue') }}
						</td>
						<td class="source-cell">{{ getSourceLabel(item) }}</td>
						<td>
							<div
								class="suggested-action-column"
								[class.manual-review]="
									getSuggestedActionTone(item) === 'manual'
								"
								[class.queued-review]="
									getSuggestedActionTone(item) === 'queued' &&
									!isItemOnHold(item)
								"
								[class.waiting-review]="isItemOnHold(item)"
							>
								<span
									class="review-badge review-badge--manual"
									*ngIf="isManualReviewRequired(item) && !isPending(item)"
								>
									<span>Revisão</span>
									<span>obrigatória</span>
								</span>
								<span
									class="review-badge"
									[class.queued]="!isItemOnHold(item)"
									[class.waiting]="isItemOnHold(item)"
									*ngIf="isPending(item)"
								>
									{{ isItemOnHold(item) ? 'Em espera' : 'Na fila' }}
								</span>
								<p class="suggested-action-text fs-xxxs">
									{{ getSuggestedActionLabel(item) }}
								</p>
								<p
									class="fs-xxxs gray action-note"
									*ngIf="getResolutionNote(item)"
								>
									{{ getResolutionNote(item) }}
								</p>
								<p
									class="fs-xxxs action-note action-note--missing"
									*ngIf="getMissingDataNote(item)"
								>
									{{ getMissingDataNote(item) }}
								</p>
								<p
									class="fs-xxxs action-note action-note--warning"
									*ngIf="getItemWarningLabels(item)"
								>
									{{ getItemWarningLabels(item) }}
								</p>
							</div>
						</td>
						<td>
							<div
								class="action-column"
								*ngIf="
									item.status === 'APPLIED' && isHistoryClickable(item);
									else editableActions
								"
							>
								<button
									mat-stroked-button
									color="primary"
									[disabled]="isPendingChangeMutationBlocked"
									(click)="onOpenResolution(item); $event.stopPropagation()"
								>
									Editar
								</button>
							</div>
							<ng-template #editableActions>
								<div
									class="action-column"
									[ngSwitch]="
										item.status === 'FAILED' ? null : getActionMode(item)
									"
								>
									<div
										class="action-column action-column--failed"
										*ngIf="item.status === 'FAILED'"
									>
										<button
											mat-stroked-button
											color="primary"
											[disabled]="isPendingChangeMutationBlocked"
											(click)="onOpenResolution(item); $event.stopPropagation()"
										>
											Editar
										</button>
									</div>
									<ng-container *ngSwitchCase="'REVIEW_ONLY'">
										<span class="review-badge">Sem ação automática</span>
									</ng-container>

									<ng-container *ngSwitchCase="'AUTO_APPLY'">
										<div *ngIf="!isPending(item)">
											<button
												mat-stroked-button
												color="primary"
												[disabled]="
													item.status === 'APPLIED' ||
													isPendingChangeMutationBlocked
												"
												(click)="
													onOpenResolution(item); $event.stopPropagation()
												"
											>
												{{ getInteractionButtonLabel(item) }}
											</button>
										</div>
										<div class="queued-state" *ngIf="isPending(item)">
											<div class="queued-state__actions">
												<button
													mat-button
													color="primary"
													[disabled]="isPendingChangeMutationBlocked"
													(click)="
														onOpenResolution(item); $event.stopPropagation()
													"
												>
													Editar
												</button>
											</div>
										</div>
									</ng-container>

									<ng-container *ngSwitchCase="'MANUAL_APPLY'">
										<div *ngIf="!isPending(item)">
											<button
												mat-stroked-button
												color="primary"
												[disabled]="
													item.status === 'APPLIED' ||
													isPendingChangeMutationBlocked
												"
												(click)="
													onOpenResolution(item); $event.stopPropagation()
												"
											>
												{{ getInteractionButtonLabel(item) }}
											</button>
										</div>
										<div class="queued-state" *ngIf="isPending(item)">
											<div class="queued-state__actions">
												<button
													mat-button
													color="primary"
													[disabled]="isPendingChangeMutationBlocked"
													(click)="
														onOpenResolution(item); $event.stopPropagation()
													"
												>
													Editar
												</button>
											</div>
										</div>
									</ng-container>
								</div>
							</ng-template>
						</td>
					</tr>
				</tbody>
			</table>
		</ng-template>
	</div>

	<app-pagination
		*ngIf="isItemTableActive && itemsTotalPages > 1"
		[count]="itemsCount"
		[currentPage]="itemsCurrentPage"
		[limit]="filterForm.get('limit')?.value"
		[totalPages]="itemsTotalPages"
		(pageChange)="onChangeItemsPage($event)"
	></app-pagination>

	<app-pagination
		*ngIf="!isItemTableActive && localTotalPages > 1"
		[count]="
			isUncomparedLinesActive
				? filteredUncomparedRows.length
				: filteredUnidentifiedOrganizationGroups.length
		"
		[currentPage]="itemsCurrentPage"
		[limit]="filterForm.get('limit')?.value"
		[totalPages]="localTotalPages"
		(pageChange)="onChangeItemsPage($event)"
	></app-pagination>

	<div
		class="context-action-bar context-action-bar--end"
		*ngIf="canShowSelectedCardMassActions"
	>
		<div></div>
		<div class="context-action-bar__actions">
			<button
				mat-stroked-button
				color="primary"
				type="button"
				[disabled]="
					isBulkCardActionRunning ||
					isPendingChangeMutationBlocked ||
					!canHoldPendingInSelectedCard
				"
				(click)="
					isTopCardActive
						? onIgnoreAllActiveTopCard()
						: onBulkIgnoreCurrentSection()
				"
			>
				<mat-spinner *ngIf="isBulkIgnoring" diameter="18"></mat-spinner>
				<span *ngIf="!isBulkIgnoring">{{ holdPendingButtonLabel }}</span>
			</button>
			<button
				*ngIf="canShowIgnoreAllCasesAction"
				mat-stroked-button
				color="warn"
				type="button"
				[disabled]="isBulkCardActionRunning || !canIgnoreAllCasesInSelectedCard"
				(click)="onIgnoreAllCasesInSelectedCard()"
			>
				<mat-spinner *ngIf="isBulkIgnoringAll" diameter="18"></mat-spinner>
				<span *ngIf="!isBulkIgnoringAll">
					Ignorar casos não resolvidos desse card
				</span>
			</button>
		</div>
	</div>
</section>
